import clsx from "clsx";
import type { RarityName } from "@/lib/abis";

const CLS: Record<RarityName, string> = {
  COMMON: "bg-common/10 text-common border-common/40",
  UNCOMMON: "bg-uncommon/10 text-uncommon border-uncommon/50 shadow-[0_0_6px_rgba(52,211,153,0.3)]",
  RARE: "bg-rare/10 text-rare border-rare/50 shadow-[0_0_6px_rgba(96,165,250,0.4)]",
  MYTHIC: "bg-mythic/10 text-mythic border-mythic/50 shadow-[0_0_8px_rgba(192,132,252,0.45)]",
  LEGENDARY: "bg-legendary/10 text-legendary border-legendary/60 shadow-[0_0_10px_rgba(251,191,36,0.55)]",
};

export function RarityPill({ rarity }: { rarity: RarityName }) {
  return (
    <span
      className={clsx(
        "inline-block rounded border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-widest font-mono",
        CLS[rarity]
      )}
    >
      {rarity}
    </span>
  );
}
